import footerLogo from "../../../assets/logos/masar-logo-footer.png"

export default function FooterLogo() {

    return (
        <img src={footerLogo} alt="Logo-Masar" className="logo-footer col-4 col-lg-3" />
    );
}